import { render, staticRenderFns } from "./release-process.vue?vue&type=template&id=60fc4d13&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fc4d13",
  null
  
)

export default component.exports